import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithRedirect,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  setPersistence,
  browserLocalPersistence,
  sendPasswordResetEmail,
  signOut,
} from 'firebase/auth'
import { getActivePinia } from 'pinia'
import type { UserInformationToCreate } from '~/functions/types/user'
import { CloudFunctions } from '~/constants/firebase/cloud-functions'

export const createUser = async (user: {
  firstName: string
  lastName: string
  email: string
  password: string
}) => {
  const auth = getAuth()
  await createUserWithEmailAndPassword(auth, user.email, user.password)
  await useHttpsCallable<UserInformationToCreate>(
    CloudFunctions.SetUserInformation,
    {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      displayName: `${user.firstName} ${user.lastName}`,
    },
  )
}

export const signInUserWithEmailAndPassword = async (
  email: string,
  password: string,
) => {
  const auth = getAuth()
  await setPersistence(auth, browserLocalPersistence)
  return await signInWithEmailAndPassword(auth, email, password)
}

export const signInUserWithGoogle = async () => {
  const auth = getAuth()
  const provider = new GoogleAuthProvider()
  await setPersistence(auth, browserLocalPersistence)
  return isInExtension()
    ? await signInWithPopup(auth, provider)
    : await signInWithRedirect(auth, provider)
}

export const signInUserWithMicrosoft = async () => {
  const auth = getAuth()
  const provider = new OAuthProvider('microsoft.com')
  provider.setCustomParameters({
    prompt: 'select_account',
  })
  await setPersistence(auth, browserLocalPersistence)
  return isInExtension()
    ? await signInWithPopup(auth, provider)
    : await signInWithRedirect(auth, provider)
}

export const sendUserPasswordResetEmail = async (email: string) => {
  const auth = getAuth()
  await sendPasswordResetEmail(auth, email)
}

export const signOutUser = async () => {
  const auth = getAuth()
  await signOut(auth)
  const pinia = getActivePinia()
  if (pinia) {
    // @ts-expect-error - Pinia internal API
    pinia._s.forEach((store: any) => store.$reset())
  }
}
